import { createRouter, createWebHistory } from 'vue-router';

import OrderSearch from '../views/saleOrder/OrderSearch.vue'
import ProductSearch from '../views/saleOrder/ProductSearch.vue'
import ProduceOrder from '../views/saleOrder/ProduceOrder.vue'
import {isMobile} from '../../public/js/index.js'
import register from '../views/Register.vue';
import Login from '../views/Login.vue'
import WXAuth from '../views/Auth.vue'
import Callback from '../views/Callback.vue'
import kongrongMumber from '../views/organization/member.vue'
import kangRongDepart from '../views/organization/department.vue'
import menu from '../views/home.vue';
import contrast from '../views/about.vue';
import tools from '../views/tools.vue';
import develop from '../views/developing.vue';
import activeSale from '../views/saleServe/activeSale.vue';
import unMatchSale from '../views/saleServe/unMatchSale.vue';
import comModity from '../views/baseData/commodity.vue';
import signReceipt from "@/views/saleServe/signReceipt.vue";
import orderPlatform from "@/views/baseData/orderPlatform.vue";
import shopList from "@/views/baseData/shopList.vue"
import bbyChannel from "@/views/channel/bby.vue"
import shopifyChannel from "@/views/channel/shopify.vue"
import stampConfig from "@/views/channel/stampConfig.vue"
import mabangToKindee from "@/views/channel/mabangToKindee.vue"
import shopifyVedio from "@/views/resource/shopifyVedio.vue";
import shopifyOrder from "@/views/resource/shopifyOrder.vue";
import orderResendEmail from "@/views/saleServe/orderResendEmail.vue";
import shopifyProblem from "@/views/resource/shopifyProblem.vue";
import operationLog from "@/views/saleServe/operationLog.vue";
import pcTempInStore from "@/views/saleServe/tempInStore.vue"
import ZohoCrm from "@/views/saleServe/shopifyTozoho.vue";
import indexEdi from "@/views/edi/IndexEdi.vue"
import addEdi from "@/views/edi/AddEdi.vue"

import mobileIndex   from "@/views/mobile/index.vue";
// import returnInfo   from "@/views/mobile/returnAndScanning.vue";
import inStore   from "@/views/mobile/inStore.vue";
import tempInStore   from "@/views/mobile/tempInStore.vue";
import sacnImage   from "@/views/mobile/sacnImage.vue";
import returnList   from "@/views/mobile/returnList.vue";
import outList   from "@/views/mobile/outList.vue";
import outSelect from "@/views/mobile/outSelect.vue";
import transferList from "@/views/mobile/transfer.vue";
import transferOut from "@/views/mobile/transferOut.vue";


const routes = [
    {
        path: '/',
        name: 'tableList',
        component: menu,
        children:[
            {
                path: '',
                component: develop,
                meta: {title: '康荣业务中台' , requiresAuth: true },
                children: [

                ]
            },
            {
                path: '/saleOrder',
                component: OrderSearch,
                meta: {title: '销售看板' , requiresAuth: true },
                children: [

                ]
            },
            {
                path: '/product',
                component: ProductSearch,
                meta: { title: '产品查询' }
            },
            {
                path: 'produce',
                component: ProduceOrder,
                meta: { title: '生产计划订单' }
            },
            {
                path: '/contrast',
                name: 'contrast',
                component: contrast,
                meta: {title: '尾程收费看板'},
            },
            {
                path: '/kMumber',
                name: 'kMumber',
                component: kongrongMumber,
                meta: {title: "康荣组织成员"}
            },
            {
                path: '/kDepartment',
                name: 'kDepartment',
                component: kangRongDepart,
            },
            {
                path: '/activeSale',
                name: 'activeSale',
                component: activeSale,
            },
            {
                path: '/unMatchSale',
                name: 'unMatchSale',
                component: unMatchSale,
            },
            {
                path: '/comModity',
                name: 'comModity',
                component: comModity,
            },
            {
                path: '/signReceipt',
                name: 'signReceipt',
                component: signReceipt,
            },
            {
                path: '/orderPlatform',
                name: 'orderPlatform',
                component: orderPlatform,
            },
            {
                path: '/shopList',
                name: 'shopList',
                component: shopList,
            },
            {
                path: '/shopVideo',
                name: 'shopVideo',
                component: shopifyVedio,
            },
            {
                path: '/shopifyOrder',
                name: 'shopifyOrder',
                component: shopifyOrder,
            },
            {
                path: '/shopifyProblem',
                name: 'shopifyProblem',
                component: shopifyProblem,
            },
            {
                path: '/stampConfig',
                name: 'stampConfig',
                component: stampConfig,
            },
            {
                path: '/bbyChannel',
                name: 'bbyChannel',
                component: bbyChannel,
            },
            {
                path: '/shopifyChannel',
                name: 'shopifyChannel',
                component: shopifyChannel,
            },
            {
                path: '/mabangToKindee',
                name: 'mabangToKindee',
                component: mabangToKindee,
            },
            {
                path: '/orderResendEmail',
                name: 'orderResendEmail',
                component: orderResendEmail,
            },
            {
                path: '/operateList',
                name: 'operateList',
                component: operationLog,
            },
            {
                path: '/pcTempInStore',
                name: 'pcTempInStore',
                component: pcTempInStore,
            },
            {
                path: '/ZohoCrm',
                name: 'ZohoCrm',
                component: ZohoCrm,
                meta: {title: 'ZohoCrm' , requiresAuth: true,equipment:"mobile" },
            },
            {
                path: '/indexEdi',
                name: 'indexEdi',
                component: indexEdi,
            },
            {
                path: '/addEdi',
                name: 'addEdi',
                component: addEdi,
            }
        ]
    },
    {
        path: '/mobile',
        name: 'mobile',
        component: mobileIndex,
        meta: {title: '退货扫码' , requiresAuth: true,equipment:"mobile"},
        children:[
            // {
            //     path: '',
            //     name: 'returnInfo',
            //     component: returnInfo,
            //     meta: {title: '退货扫码' , requiresAuth: true,equipment:"mobile" },
            // },
            {
                path: '',
                name: 'returnList',
                component: returnList,
                meta: {title: '退货列表' , requiresAuth: true,equipment:"mobile" },
            },
            {
                path: '/inStore',
                name: 'inStore',
                component: inStore,
                meta: {title: '退货入库' , requiresAuth: true,equipment:"mobile" },
            },
            {
                path: '/sacnImage',
                name: 'sacnImage',
                component: sacnImage,
                meta: {title: '扫码入库' , requiresAuth: true,equipment:"mobile" },
            },

            {
                path: '/outList',
                name: 'outList',
                component: outList,
                meta: {title: '扫码入库' , requiresAuth: true,equipment:"mobile" },
            },
            {
                path: '/outSelect',
                name: 'outSelect',
                component: outSelect,
                meta: {title: '扫码入库' , requiresAuth: true,equipment:"mobile" },
            },
            {
                path: '/transferList',
                name: 'transferList',
                component: transferList,
                meta: {title: '维修入库' , requiresAuth: true,equipment:"mobile" },
            },
            {
                path: '/transferOut',
                name: 'transferOut',
                component: transferOut,
                meta: {title: '维修入库' , requiresAuth: true,equipment:"mobile" },
            },
            {
                path: '/tempInStore',
                name: 'tempInStore',
                component: tempInStore,
                meta: {title: '签收入库' , requiresAuth: true,equipment:"mobile" },
            },
        ]
    },
    {
        path: '/login',
        name: 'Login',
        component: Login
    },
    {
        path: '/auth',
        name: 'Auth',
        component: WXAuth
    },
    {
        path: '/callback',
        component: Callback
    },
    {
        path: '/product',
        component: ProductSearch,
        meta: { title: '产品查询' }
    },
    {
        path: '/register',
        component: register,
        meta: { title: '注册' }
    },
    {
        path: '/tools',
        name: 'tools',
        component: tools,
        meta: {title: '运费计算工具'},
    },
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
});


router.beforeEach((to, from, next) => {
    console.log(isMobile())
    console.log(to.meta.equipment)
    if (to.meta.title) {
        document.title = to.meta.title
    }
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if(!localStorage.getItem('token')){
            if(isMobile() && (to.meta.equipment!="mobile")){
                //next('/auth')
                next('/login')
            }else {
                next('/login')
            }
        }else{
            if(isMobile() && (to.meta.equipment!="mobile")){
                next('/mobile')
            }else {
                next()
            }
        }
    } else {
        next()
    }
})

export default router;